import React from 'react';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import { DirtyWarningConsumer, DirtyWarningInputProps, DirtyWarningContextShape } from '../DirtyWarning';

export interface CurrencyInputProps extends DirtyWarningInputProps {
   name: string;
   onChange?: (e: React.FormEvent<FormControl>) => void;
   onFocus?: (e: React.FormEvent<FormControl>) => void;

   label?: string;
   key?: string;    
   placeholder?: string;
   value?: number;
   readOnly?: boolean;
   disabled?: boolean;
   pattern?: string;
   type?: string;

   validationState?: () => 'success' | 'warning' | 'error' | null;
}

type State = {
   isEditing: boolean
}

export class CurrencyInput extends React.Component<CurrencyInputProps, State> 
{
   constructor(props: CurrencyInputProps) {
      super(props);
      this.state = {isEditing: false};
   }
      
   toCurrency(n: number) {
      const formatter = new Intl.NumberFormat("en-US", {
         style: "currency",
         currency: "USD"
       });
       return formatter.format(n);
   }

   setEditing(editing: boolean) {
      this.setState({ isEditing: editing });
    }

   render() {
      const { validationState, disableDirtyTracking = false, onFocus, onChange, ...textBoxProps} = this.props;
      const validationStateResult = validationState ? validationState() : null;

      const handleChange = (context: DirtyWarningContextShape, e: React.FormEvent<FormControl>) => {
         if (onChange){
            onChange(e);
         }

         if (!disableDirtyTracking) {
            context.setDirty(true);
         }
      }

      const handleFocus = (e: React.FormEvent<FormControl>) => {
         this.setEditing(true);

         if (onFocus) {
            onFocus(e);
         }
      }

      let guts = (
         <DirtyWarningConsumer>
            {context => (
               <FormControl 
                  {...textBoxProps}
                  componentClass="input"
                  type={this.state.isEditing ? "number" : "text"}
                  value={this.state.isEditing ? this.props.value : this.toCurrency(this.props.value || 0)}
                  onChange={(e) => handleChange(context, e)}
                  onBlur={(p) => {console.log(p); if (this.state.isEditing) this.setEditing(false)}}
                  onClick={(p) => this.setEditing(true)}
                  onFocus={handleFocus}
               />
            )}            
         </DirtyWarningConsumer>         
      );

      return (this.props.label) ? (
         <FormGroup controlId={this.props.key} validationState={validationStateResult}>
            <ControlLabel>{this.props.label}</ControlLabel>
            {guts}
         </FormGroup>
      ) : guts;

   }
}

(CurrencyInput as any).displayName = 'CurrencyInput';